import { HoursOfBase } from "./hours-of-base";

export class HoursOfRestriction extends HoursOfBase {

}
